import { makeStyles } from '@mui/styles';
import IconButton from 'apollo-react/components/IconButton';
import List from 'apollo-react/components/List';
import ListItem from 'apollo-react/components/ListItem';
import ListItemText from 'apollo-react/components/ListItemText';
import Popover from 'apollo-react/components/Popover';
import Tooltip from 'apollo-react/components/Tooltip';
import CopyIcon from 'apollo-react-icons/Copy';
import React from 'react';

import { useTranslation } from '../../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  label: {
    cursor: 'default',
    '& span': {
      fontWeight: 700,
    },
  },
  option: {
    paddingTop: 0,
    paddingLeft: 40,
    cursor: 'pointer',
  },
  listItem: {
    cursor: 'pointer',
  },
});

const renderListItem = ({
  option,
  index,
  onSelect,
  enableCopy,
  classes,
  translateString,
  popoverProps,
}) => {
  const handleClickCopy = () => {
    navigator.clipboard.writeText(option.value);
    popoverProps.onClose();
  };

  return option.label ? (
    <>
      <ListItem key={classes.label + index}>
        <ListItemText className={classes.label} primary={translateString(option.label)} disabled />
      </ListItem>
      <ListItem key={index} className={classes.option}>
        <ListItemText primary={option.value} onClick={() => onSelect(option.value)} />
        {enableCopy && (
          <Tooltip title="Copy" disableFocusListener>
            <IconButton onClick={handleClickCopy}>
              <CopyIcon />
            </IconButton>
          </Tooltip>
        )}
      </ListItem>
    </>
  ) : (
    <ListItem key={index} onClick={() => onSelect(option)}>
      <ListItemText primary={option} className={classes.listItem} />
    </ListItem>
  );
};

const LookupPopover = ({ options = [], enableCopy = false, onSelect, ...popoverProps }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  return (
    <Popover {...popoverProps} disableEnforceFocus>
      <List>
        {options.map((option, index) =>
          renderListItem({
            option,
            index,
            onSelect,
            enableCopy,
            classes,
            translateString,
            popoverProps,
          })
        )}
      </List>
    </Popover>
  );
};

export default LookupPopover;
